import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../Store';
import { updateBillingPermissionAsync } from '../../../Utils/api';
import { ButtonColor, Role } from '../../../Utils/constants';
import BillingPermissionModal from '../Modals/BillingPermissionModal';

const BillingPermissionsButton = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isPermissionModalOpen, setIsPermissionModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const customer = useSelector((state: RootState) => state.signup.customer?.customer);
  const role = useSelector((state: RootState) => state.admin?.adminUser?.customer?.user?.role);
  const customerId = useSelector((state: RootState) => state.admin?.currentCustomer);

  const handleBillingPermission = () => {
    if (customerId) {
      setIsPermissionModalOpen(false);
      dispatch(updateBillingPermissionAsync(customerId, true, setIsLoading, setErrorMessage, null));
    }
  };

  return (
    <div>
      {role === Role.ADMIN &&
        customer?.status === 'pending-review' &&
        !customer?.pscPermissionGranted && (
          <div className="flex flex-col ms-2">
            <button
              className={`rounded-[10px] px-2 py-2 min-w-[140px] text-sm ${ButtonColor.SECONDARY}`}
              onClick={() => setIsPermissionModalOpen(true)}
            >
              Approve
            </button>
          </div>
        )}
      {isPermissionModalOpen && (
        <BillingPermissionModal
          setIsModalOpen={setIsPermissionModalOpen}
          handleYes={handleBillingPermission}
          isLoading={isLoading}
          errorMessage={errorMessage}
        />
      )}
    </div>
  );
};

export default BillingPermissionsButton;
